<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useCardStore } from "#/store/card";
import { useDecorationStore } from "#/store/decoration";

const cardStore = useCardStore();
const decor = useDecorationStore().screen("product_card");
const { stateCard } = storeToRefs(cardStore);
const router = useRouter();

const props = defineProps<{
	qr_menu?: boolean;
}>();

const minusNumber = () => {
	if ((router.options.history.state?.back as string)?.includes("mode=pdf") && props.qr_menu) return;
	if (stateCard.value.openCard?.amount && stateCard.value.openCard?.amount > 1) {
		stateCard.value.openCard!.amount -= 1;
	}
};

const plusAmount = () => {
	if ((router.options.history.state?.back as string)?.includes("mode=pdf") && props.qr_menu) return;
	if(stateCard.value.openCard?.is_marked) return;
	if (stateCard.value.openCard?.amount) {
		stateCard.value.openCard.amount += 1;
	}
};
</script>

<template>
	<div class="counter_container">
		<div class="card_size_place_wrapper" ref="sliderWrapper">
			<div class="cart_amount_counter" v-bind="decor.bind('quantity')">
				<p
					class="cart_circle_minus"
					:class="[stateCard.openCard?.amount === 1 ? 'card_circle_minus_alone' : '']"
					data-clickable="true"
					v-bind="decor.bind('quantity_minus')"
					@click.stop.prevent="minusNumber"
				>
					<span></span>
				</p>
				<p class="button_circle_number" v-bind="decor.bind('quantity_value')">{{ stateCard.openCard?.amount }}</p>
				<p class="cart_circle_plus" data-clickable="true" v-bind="decor.bind('quantity_plus')" @click.stop.prevent="plusAmount">+</p>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
  @use './cardProduct.scss';
</style>
